module.exports = __webpack_public_path__ + "img/cap-front.1aec60e3.svg";